import React from "react";
import { Button } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

export default function BackButton({ history, sx }) {
  return (
    <Button
      aria-label="Go back"
      startIcon={<ArrowBackIcon />}
      onClick={() => history?.goBack()}
      sx={{
        mr: "16px",
        flexShrink: 0,
        px: 2,
        py: 0.75,
        borderRadius: "999px",
        textTransform: "none",
        fontWeight: 700,
        color: "#4f46e5",
        backgroundColor: "#eef2ff",
        backgroundImage: "none",
        border: "1px solid #dcdff5",
        boxShadow: "none",
        "&:hover": { backgroundColor: "#e0e7ff", boxShadow: "none" },
        ...sx,
      }}
    >
      Back
    </Button>
  );
}
